export const SPORTS = [
  "Generic / Any Sport",
  "Basketball",
  "Football (Soccer)",
  "American Football",
  "Tennis",
  "Cricket",
  "Baseball",
  "Volleyball",
  "Running / Track",
  "Swimming",
  "Cycling",
  "Golf",
  "Boxing",
  "MMA / Combat Sports",
  "Wrestling",
  "Hockey",
  "Gymnastics",
  "Rugby",
  "Esports",
  "Other",
];
